export default __webpack_public_path__ + "static/media/pgmico(8).6a17857b.png";